export default "__VITE_ASSET__BkfcVRxq__"